<template>
  <div class="select-refund">
    <div class="select-refund-list">
      <h4 class="list-title">选择退款商品</h4>
      <van-checkbox-group v-model="checked" ref="drugCheck">
        <div v-for="(item, key) in orderList" :key="key.orderDetailId">
          <van-swipe-cell>
            <div class="flex check-item">
              <van-checkbox
                :name="item.orderDetailId"
                :disabled="!item.canRefund"
                @click="handleClick(item.orderDetailId)"
                class="check-request flex center"
              ></van-checkbox>
              <div class="product-item-re">
                <product-item :item="item" :showAction="true" :showImage="orderClassifyType != '1'"></product-item>
              </div>
            </div>
            <div v-if="item.refundedNum" class="refunded-num">
              已申请过售后
              <span style="color: #ff8200">{{ item.refundedNum }}</span>
              件
            </div>
          </van-swipe-cell>
        </div>
      </van-checkbox-group>
    </div>

    <div class="h100"></div>
    <div class="fixed fixed-ios">
      <div class="flex space-between align-center fix-content pl16 pr16">
        <div class="left flex align-center">
          <van-checkbox v-model="checkedAll" label-disabled @change="handleCheckAll"></van-checkbox>
          <div class="price-container">
            <div class="flex align-center">
              <span>全选</span>
            </div>
          </div>
        </div>
        <van-button
          round
          type="primary"
          size="small"
          style="width: 88px"
          v-reClick="submit"
          :disabled="!checked.length"
        >
          确定
          <span v-if="checked.length">({{ checked.length }})</span>
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import ProductItem from './components/productItem';
import jumpCenter from '@/mixins/jumpCenter';

export default {
  name: 'requestCart',
  mixins: [jumpCenter],
  data() {
    return {
      orderSn: '',
      checked: [],
      checkedAll: false, // 是否全选
      orderList: [],

      load: false,
      activeDrugStatus: '1', // 0 非药品 1 药品
      CAN_REFUND_ALL: false, // 不能退全部
      orderClassifyType: '2' // 1 中药 2 西药
    };
  },
  components: {
    ProductItem
  },
  watch: {
    checked() {
      const len = this.orderList.length;

      if (len) this.checkedAll = this.checked.length === len;
    }
  },

  async created() {
    await this.fetchCartList();
    const { orderClassifyType = '2' } = this.$route.query;
    this.orderClassifyType = orderClassifyType;
    if (orderClassifyType == '1') {
      this.toggleCheckAll(true);
      this.submit();
    }
  },

  methods: {
    // 检查是否全选
    checkIsChoAll() {
      const len = this.orderList.length;
      if (len) this.checkedAll = this.checked.length == len;
    },

    handleCheckAll() {
      const len = this.orderList.length;
      if (this.checkedAll) {
        this.toggleCheckAll(this.checkedAll);
      } else {
        if (this.checked.length === len) this.toggleCheckAll();
      }
    },

    toggleCheckAll(checkedAll) {
      this.checked = [];
      if (checkedAll) {
        this.checked = this.orderList.filter((ele) => ele.canRefund).map((ele) => ele.orderDetailId);
      }
    },

    handleClick(id, item, num) {
      this.checkedAll = this.checked.length === this.orderList.length;
    },

    async fetchCartList() {
      this.load = true;
      const { orderSn = '' } = this.$route.query;
      this.orderSn = orderSn;

      const res = await this.$fetch.getRefundGoodsInOrder({ orderSn });

      this.orderList = res.map((ele) => {
        ele.refundNum = ele.maxRefundNum;
        return ele;
      });
      this.checkIsChoAll();

      // if (!this.CAN_REFUND_ALL) {
      //   this.toggleCheckAll(true);
      // }

      this.load = false;
    },

    submit() {
      const checkedList = this.orderList.filter((ele) => this.checked.includes(ele.orderDetailId) && ele.canRefund);
      localStorage.setItem('ZYYD_REFUND_GOODS', JSON.stringify(checkedList));
      const { expressFee } = this.$route.query;
      if (this.orderClassifyType == '1') {
        this.$router.replace({
          name: 'refundApply',
          query: {
            orderSn: this.orderSn,
            expressFee,
            orderClassifyType: '1'
          }
        });
      } else {
        this.$router.push({
          name: 'refundApply',
          query: {
            orderSn: this.orderSn,
            expressFee
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.select-refund {
  background: #f5f5f5;

  padding: 12px;
  &-list {
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    .list-title {
      font-size: 16px;
      font-weight: 500;
      padding: 16px 12px 0;
      color: #262626;
    }
    .check-item {
      padding: 16px 12px 12px;
    }
  }
  ::v-deep.van-checkbox {
    overflow: visible;
  }
  .refunded-num {
    background: #fafafa;
    color: #262626;
    font-size: 14px;
    padding: 11.5px 0;
    text-align: center;
    margin: 0 12px 12px;
    border-radius: 4px;
    overflow: hidden;
  }
  .tips {
    background: #ebf8ff;
    padding: 13px 16px;
    border-bottom: 1px solid #eee;
    color: #1e8dff;
    font-size: 14px;
    line-height: 14px;
  }
  .fixed {
    position: fixed;

    bottom: 0;
    left: 0;
    width: 100%;
  }
  .h100 {
    height: 140px;
  }
  .fix-content {
    background: #fff;
    height: 60px;
  }
  .price-info {
    display: flex;
    align-items: baseline;

    .rmb {
      color: #ff4e47;
      font-size: 12px;
      transform: scale(0.9, 0.9);
      transform-origin: bottom;
      font-weight: 500;
      line-height: 1;
    }

    .price-txt {
      color: #ff4e47;
      font-size: 16px;
      line-height: 1;
      margin-right: 4px;
      font-weight: 500;
    }
  }
  .price-container {
    margin-left: 8px;

    .fee-info {
      margin-top: 4px;
      font-size: 12px;
      width: 110%;
      background: transparent;
      position: relative;
      left: -5%;
      transform: scale(0.9, 0.9);

      color: #8c8c8c;
      .pri {
        color: #f23400;
      }
    }
  }
  .left {
    font-size: 14px;
    color: #333;
    .price {
      font-size: 16px;
      font-weight: 500;
      color: #f23400;
    }
  }
}
.check-request {
  min-width: 18px;
  position: relative;
  height: 68px;
  margin-right: 8px;

  // ::v-deep .van-checkbox__icon--checked {
  //   .van-icon {
  //     position: relative;
  //     &::before {
  //       position: absolute;
  //       font-size: 12px;
  //       top: 2px;
  //       left: 1px;
  //     }
  //   }
  // }
}
.product-item-re {
  width: 89.4%;
}
.delete-button {
  width: 60px;
  font-size: 16px;
  padding: 0;
  background: #e63d3d;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
